export class PagerStateModel {
    lastPage: number;
    lastPageSize: number;
    totalRecords: number;
    dateTime: number;
    startIndex: number;
    endIndex: number;
}
